<template>
    <div class="register">
      <p><i @click="goBack('login')">&#10005</i></p>
     <!-- <div v-if="registerName === '供应商'">
        <label><i>*</i>{{registerName}}编号：</label>
        <input type="text" title="注册供应商编号" v-model.trim="supplierNum" @blur="verifityRegister('supplierNumWarn')" @keyup="verifityRegister('supplierNumWarn')">
        <p>{{supplierNumWarn}}</p>
      </div> -->
      <div>
        <label><i>*</i>{{registerName}}名称：</label>
        <input type="text" title="注册名称" maxlength="50"
               v-model.trim="name"
               @blur="verifityRegister('nameWarn')"
               @keyup="verifityRegister('nameWarn')">
        <p>{{nameWarn}}</p>
      </div>
      <div>
        <label><i>*</i>登录账号：</label>
        <input type="text" title="登录账号" maxlength="36"
               v-model.trim="loginNum"
               @blur="verifityRegister('loginNumWarn')"
               @keyup="verifityRegister('loginNumWarn')">
        <p>{{loginNumWarn}}</p>
      </div>
      <div>
        <label><i>*</i>登录密码：</label>
        <input type="password" title="登录密码" maxlength="30"
               v-model.trim="loginPwd"
               @blur="verifityRegister('loginPwdWarn')"
               @keyup="verifityRegister('loginPwdWarn')">
        <p>{{loginPwdWarn}}</p>
      </div>
      <div>
        <label><i>*</i>确认密码：</label>
        <input type="password" title="确认密码" maxlength="30"
               v-model.trim="confirmPwd"
               @blur="verifityRegister('confirmPwdWarn')"
               @keyup="verifityRegister('confirmPwdWarn')">
        <p>{{confirmPwdWarn}}</p>
      </div>
      <div>
        <label><i>*</i>手机号：</label>
        <input type="text" title="手机号" maxlength="25"
               v-model.trim="tel"
               @blur="verifityRegister('telWarn')"
               @keyup="verifityRegister('telWarn')">
        <p>{{telWarn}}</p>
      </div>
      <!--手机验证码-->
     <!-- <div>
        <label><i>*</i>验证码：</label>
        <input type="text" title="验证码" maxlength="10"
               v-model.trim="verificationCode"
               @blur="verifityRegister('verificationCodeWarn')"
               @keyup="verifityRegister('verificationCodeWarn')">
        <a v-if="verificationCodeBtn === '发送验证码'" @click="sendCode()">发送验证码</a>
        <a v-if="verificationCodeBtn === '已发送验证码'" title="已发送验证码不能再点击">已发送验证码</a>
      </div> -->
      <!--纯前台验证码-->
      <div class="check_code">
        <label><i>*</i>验证码：</label>
        <div class="inb">
          <input class="fl" type="text"
                 v-model.trim="verificationCode"
                 @blur="verifityRegister('verificationCodeWarn')">
          <input @click="createCode()" type="button" title="验证码60s刷新一次" v-model="checkCode">
        </div>
        <p>{{verificationCodeWarn}}</p>
      </div>
      <div class="flex">
        <label>公司地址：</label>
        <textarea name="adress" title="公司地址" maxlength="200"
                  v-model.trim="address" cols="30" rows="10"></textarea>
      </div>
      <div>
        <p v-if="registerError">{{registerError}}</p>
      </div>
      <div class="text_center register_btn">
        <button v-if="name && loginNum && loginPwd && confirmPwd && tel && verificationCode" @click="registerBtn()">注册</button>
        <button v-if="!name || !loginNum || !loginPwd || !confirmPwd || !tel || !verificationCode" class="forbid">注册</button>
      </div>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
    </div>
</template>

<script>
  import LoadingDialog from '../public-component/loading-dialog';

    export default {
      name: 'register',
      props: ['registerType'],
      comments: {LoadingDialog},
      data() {
          return {
            spUrl: '', // 供应商登录地址
            showType: '', // 返回登录页面
            type: '', // 注册类型：分销商=px    供应商=sp
            // supplierNum: '', // 供应商编号
            // supplierNumWarn: '', // 供应商编号警告
            registerName: '', // 注册的名称
            name: '', // 分销商/供应商名称
            nameWarn: '', // 分销商/供应商名称警告
            loginNum: '', // 登录账号
            loginNumWarn: '', // 登录账号警告
            loginPwd: '', // 登录密码
            loginPwdWarn: '', // 登录密码警告
            confirmPwd: '', // 确认密码
            confirmPwdWarn: '', // 确认密码警告
            tel: '', // 手机号
            telWarn: '', // 手机号警告
            checkCode: '', // 生成的验证码
            verificationCode: '', // 验证码
            verificationCodeBtn: '发送验证码', // 发送验证码按钮
            verificationCodeWarn: '', // 验证码警告
            address: '', // 公司地址
            registerError: '', // 注册失败原因
            isLoading: false // 是否显示加载框
          }
      },
      methods: {
        // 注册按钮
        registerBtn() {
          // 再一次验证
          this.verifityRegister('nameWarn');
          this.verifityRegister('loginNumWarn');
          this.verifityRegister('loginPwdWarn');
          this.verifityRegister('confirmPwdWarn');
          this.verifityRegister('telWarn');
          this.verifityRegister('verificationCodeWarn');
          if (!this.nameWarn && !this.loginNumWarn && !this.loginPwdWarn && !this.confirmPwdWarn && !this.telWarn && !this.verificationCodeWarn) {
            let sType;
            if (this.registerType === 'proxy') {
              sType = 'px';
              /* if (this.name && this.loginNum && this.loginPwd && this.confirmPwd && this.tel && this.verificationCode) {
                const params = {
                  // code: 1,
                  clientName: this.name,
                  loginName: this.loginNum,
                  loginPwd: this.loginPwd,
                  comireloginPwd: this.confirmPwd,
                  phone: this.tel,
                  verifyCode: this.verificationCode,
                  companyAddress: this.address,
                  sType: 'px'
                };
                this.$axios.post(this.Global.registerUrl, params).then((res) => {
                  if (!res.data.errorMsg.length) {
                    this.goBack('alertSuc');
                  } else {
                    this.registerError = res.data.errorMsg;
                  }
                });
              } else {
                this.registerError = '请将带*的内容填写正确';
              } */
            } else {
              sType = 'sp';
              // this.verifityRegister('supplierNumWarn');
             /* if (!this.supplierNumWarn) {
                if (this.supplierNum && this.name && this.loginNum && this.loginPwd && this.confirmPwd && this.tel && this.verificationCode) {
                  const params = {
                    code: this.supplierNum,
                    clientName: this.name,
                    loginName: this.loginNum,
                    loginPwd: this.loginPwd,
                    comireloginPwd: this.confirmPwd,
                    phone: this.tel,
                    verifyCode: this.verificationCode,
                    companyAddress: this.address,
                    sType: 'sp'
                  };
                  this.$axios.post(this.Global.registerUrl, params).then((res) => {
                    if (!res.data.errorMsg.length) {
                      this.goBack('alertSuc');
                    } else {
                      this.registerError = res.data.errorMsg;
                    }
                  });
                } else {
                  this.registerError = '请将带*的内容填写正确';
                }
              } */
            }

            if (this.name && this.loginNum && this.loginPwd && this.confirmPwd && this.tel) {
              this.isLoading = true;
              const params = {
                // code: this.supplierNum,
                clientName: this.name,
                loginName: this.loginNum,
                loginPwd: this.loginPwd,
                comireloginPwd: this.confirmPwd,
                phone: this.tel,
                // verifyCode: this.verificationCode,
                companyAddress: this.address,
                sType: sType
              };
              this.$axios.post(this.Global.registerUrl, params).then((res) => {
                if (res) {
                  if (!res.data.errorMsg.length) {
                    this.isLoading = false;
                    this.goBack('alertSuc');
                  } else {
                    this.isLoading = false;
                    this.registerError = res.data.errorMsg;
                    if (res.data.errorMsg === '验证码失效或已过期。') {
                      this.verificationCodeBtn = '发送验证码';
                    }
                  }
                } else {
                  this.isLoading = false;
                }
              });
            } else {
              this.registerError = '请将带*的内容填写正确';
            }
          }
        },

        // 验证注册信息
        verifityRegister (type) {
          switch (type) {
           /* case 'supplierNumWarn':
              if (!this.supplierNum) {
                this.supplierNumWarn = '供应商编号不能为空';
              } else {
                this.supplierNumWarn = '';
              }
              break; */
            case 'nameWarn':
              if (!this.name) {
                this.nameWarn = this.registerName + '名称不能为空';
              } else {
                this.nameWarn = '';
              }
              break;
            case 'loginNumWarn':
              if (!this.loginNum) {
                this.loginNumWarn = '登录账号不能为空';
              } else {
                this.loginNumWarn = '';
              }
              break;
            case 'loginPwdWarn':
              if (!this.loginPwd) {
                this.loginPwdWarn = '登录密码不能为空';
              } else {
                this.loginPwdWarn = '';
              }
              break;
            case 'confirmPwdWarn':
              if (!this.confirmPwd) {
                this.confirmPwdWarn = '确认密码不能为空';
              } else if (this.loginPwd !== this.confirmPwd) {
                this.confirmPwdWarn = '两次密码不一致，请重新输入';
              } else {
                this.confirmPwdWarn = '';
              }
              break;
            case 'telWarn':
              if (!this.tel) {
                this.telWarn = '手机号不能为空';
              } else if (!this.phoneCheck(this.tel)) {
                this.telWarn = '请输入正确的手机号';
              } else {
                this.telWarn = '';
              }
              break;
            case 'verificationCodeWarn':
              if (!this.verificationCode) {
                this.verificationCodeWarn = '验证码不能为空';
              } else if (this.verificationCode !== this.checkCode) {
                this.verificationCodeWarn = '验证码错误,请注意大小写';
              } else {
                this.verificationCodeWarn = '';
              }
              break;
          }
        },

        // 手机号正则表达式
        phoneCheck (num) {
          // /^1(3|4|5|7|8)\d{9}$/
          const reg = /^[1][0-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
          // const reg = /^1([34578])\d{9}$/;
          return reg.test(num);
        },

        // 发送验证码
        sendCode () {
          if (!this.tel) {
            this.telWarn = '发送失败，请输入手机号';
          } else if (!this.phoneCheck(this.tel)) {
            this.telWarn = '发送失败，请输入正确的手机号';
          } else {
            this.$axios.get(this.Global.sendVerifyCode(this.tel, this.type)).then((res) => {
              console.log(res);
              if (!res.data.errorMsg.length) {
                this.telWarn = '';
                this.verificationCodeBtn = '已发送验证码';
              } else {
                this.telWarn = res.data.errorMsg;
              }
            });
          }
        },

        // 图片验证码
        createCode() {
          this.checkCode = '';
          let times = 60;
          const self = this;
          let timer;
          // 验证码长度
          const codeLen = 4;
          // 随机数
          const random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
            'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        // 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
        // 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
          for (let i = 0; i < codeLen; i++) {
            // 取得随机数的索引
            const index = Math.floor(Math.random() * 36);
            this.checkCode += random[index];
          }
          timer = setInterval(function () {
            times = --times;
            console.log(times);
            if (times < 1) {
              clearInterval(timer);
              self.createCode();
            }
          }, 1000);
        },

        // 刷新验证码
        refreshCode() {
          this.createCode();
        },

        // 返回登录页
        goBack (showType) {
          let path = '/login';
          if (showType === 'supplier') {
            path = this.spUrl + '/login';
          }
          this.$router.push({
            // path: '/login'
            path: path
          });
          this.$emit('goBack', {showType: showType, registerType: this.registerType});
        }
      },
      created() {
        /* 获取供应商部署地址 */
        this.$axios.get(this.Global.getSPUrl).then((res) => {
          this.spUrl = res.data.resData;
        });

        this.createCode();
        if (this.registerType === 'proxy') {
          this.registerName = '分销商';
          this.type = 'px';
        } else {
          this.registerName = '供应商';
          this.type = 'sp';
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/style";
  @import "../../assets/css/base-color";

.register {
  background-color: #fff;
  border-radius: 10px;
  text-align: left;
  width: 662px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);

  &>p {
    text-align: right;
    padding-top: 10px;
    margin: 10px;
    font-weight: 800;

    i {
      font-style: normal;

      &:hover {
        cursor: pointer;
      }
    }
  }

  &>div {
    width: 85%;
    margin: 0 auto 20px;

    &>label {
      display: inline-block;
      width: 96px;
      text-align: right;

      &>i {
        color: #ff0000;
        margin-right: 5px;
      }
    }

    &>input[type='text'], &>input[type='password'] {
      width: 60%;
      height: 30px;
      border-radius: 0;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.35);
    }

    &>p {
      width: 65%;
      margin: 5px auto 0;
      color: #ff0000;
    }

    &>textarea {
      width: 62%;
      margin-left: 3px;
      border: 1px solid #eee;
      border-radius: 0;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.35);
    }

    &>a {
      color: $loginColor;
      margin-left: 5px;

      &:hover {
        cursor: pointer;
      }
    }

    &.register_btn {
      border-radius: 0 0 10px 10px;

      button {
        width: 270px;
        height: 40px;
        line-height: 40px;
        border: none;
        border-radius: 10px;
        background-color: rgba(22, 155, 213, 1);
        font-size: 16px;
        color: #ffffff;
        margin: 30px 0 50px;

        &:hover {
          cursor: pointer;
          background-color: rgba(22, 155, 213, 0.8);
        }

        &.forbid {
          background-color: rgba(22, 155, 213, 0.8);

          &:hover {
            cursor: no-drop;
          }
        }
      }
    }
  }

  .check_code {
    input[type="text"] {
      width: 70px;
      height: 30px;
      border-radius: 0;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.35);
      margin-right: 10px;
    }

    input[type="button"] {
      width: 100px;
      height: 32px;
      border-radius: 12px;
      letter-spacing: 7px;
      margin-left: 30px;
      transform: translate(-15px,0);

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register/register.vue